import { VariablesOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { fetcherShopifyStorefront } from "@repo/graphql-shopify-storefront";
import {
  // CartBuyerIdentityUpdateMutation,
  CartCreate_Mutation,
  // CartLinesAddMutation,
  // CartLinesRemoveMutation,
  // CartLinesUpdateMutation,
} from "#/graphql/shopify-storefront/mutations/cart";
import { Cart_Query } from "#/graphql/shopify-storefront/queries/cart";

// --- Utility function to get or create cart ---
// This is used on the server to ensure a cart exists.
export async function CartQueryOrCartCreateMutationHandler({
  variables,
}: {
  variables: { cartId?: string };
}) {
  const { cartId } = variables;

  let cartMasked;

  if (cartId) {
    // If cart ID exists, attempt to fetch the existing cart.

    const queryVariables = {
      cartId,
    } satisfies VariablesOfShopifyStorefront<typeof Cart_Query>;

    ({ cartMasked } = await fetcherShopifyStorefront(
      Cart_Query,
      queryVariables,
    ));
  } else {
    // If no cart ID or cart is not found (e.g., expired), create a new cart.

    const mutationVariables = {
      input: {},
    } satisfies VariablesOfShopifyStorefront<typeof CartCreate_Mutation>;

    const { cartCreate } = await fetcherShopifyStorefront(
      CartCreate_Mutation,
      mutationVariables,
    );

    if (!cartCreate) {
      throw new Error("Failed to create cart");
    } else if (cartCreate.userErrors.length > 0) {
      throw new Error(
        `Cart creation error: ${cartCreate.userErrors.map((error) => error.message).join(", ")}`,
      );
    }

    ({ cartMasked } = cartCreate);
  }

  return cartMasked;
}
